module.exports = __webpack_public_path__ + "static/media/camera.86a078b8.png";